import { Button } from 'antd';
import styled from 'styled-components';

export const WidgetWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: fit-content;
`;

export const WidgetTitle = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const PurpleIconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.purple7};
  background: ${({ theme }) => theme.colors.purple1};
  display: flex;
  width: 24px;
  height: 24px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.purple3};
  background: ${({ theme }) => theme.colors.purple1};
`;

export const PendingTasksWrapper = styled.div`
  display: flex;
  padding: 2px 6px;
  align-items: center;
  gap: 6px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.green4};
  background: ${({ theme }) => theme.colors.green2};
  color: ${({ theme }) => theme.colors.green7};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const NoPendingTasksWrapper = styled.div`
  display: flex;
  padding: 2px 6px;
  align-items: center;
  gap: 6px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.black1};
`;

export const ShowMoreButton = styled(Button)`
  color: ${({ theme }) => theme.colors.black8};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  align-self: flex-start;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;
